import request from './request'

// 素材跟文件夹列表
export function materialGetList(params) {
  return request({
    url: '/folder/list',
    method: 'get',
    params
  })
}

// folderGetList
// 文件夹目录
export function folderGetTree() {
  return request({
    url: '/folder/tree',
    method: 'get'
  })
}

// 创建文件夹
export function folderCreate(data) {
  return request({
    url: '/folder/create',
    method: 'post',
    data
  })
}

// 编辑文件夹
export function folderEdit(id, data) {
  return request({
    url: '/folder/update/' + id,
    method: 'put',
    data
  })
}

// 编辑文件名
export function fileEdit(data) {
  return request({
    url: '/file/rename',
    method: 'post',
    data
  })
}

// 删除文件、文件夹
export function folderFileDelete(data) {
  return request({
    url: '/batch/delete',
    method: 'post',
    data
  })
}

// 上传文件
export function folderFileUpload(data) {
  return request({
    url: '/file/upload',
    method: 'post',
    data
  })
}

// 移动文件
export function folderFileMove(data) {
  return request({
    url: '/file/move',
    method: 'post',
    data
  })
}

// 共享文件
export function folderFileShare(data) {
  return request({
    url: '/share/batchshare',
    method: 'post',
    data
  })
}

// 以图搜款
export function materialSearchByImage(data) {
  return request({
    url: '/file/search',
    method: 'post',
    data
  })
}

// 按模板导出数据
export function materialExport(data) {
  return request({
    url: '/file/generateExcel',
    method: 'post',
    data
  })
}